import React, {useEffect, useState} from 'react';
import {Close} from '@material-ui/icons';
import CheckIcon from '@material-ui/icons/Check';
import {
  Button,
  makeStyles,
  Theme,
  createStyles,
  Typography
} from '@material-ui/core';
import {
  APP,
  DEFAULT_RED_COLOR,
  ENTER_CARD_BUTTON,
  GET_8_PIXEL_BOX
} from 'src/style/variable';
import {useSnackbar} from 'notistack';
import {fetchCardMachineDetails} from '@shared/services/ClinicServices';
import {useTranslation} from 'react-i18next';
import Loader from '@components/framework/loader/Loader';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import BackNavigation from 'src/modules/payments/backNavigation/BackNavigation';
import {_cardMachineDetailsObject} from '@shared/store/actions/CardMachineActions';
import {connect} from 'react-redux';
import ConfirmationDetails from '../../ConfirmationDetails';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    swipeCardButton: {
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem'
    },
    selectCardButton: {
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem',
      margin: '0 0 1rem 0',
      width: '30%'
    },
    machineDataContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      margin: '0 1rem',
      height: 'inherit'
    },
    paymentsSection: {
      marginTop: '0.5rem'
    },
    enterCardButton: {
      backgroundColor: `${ENTER_CARD_BUTTON} !important`,
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem'
    },
    machineData: {
      boxSizing: 'border-box',
      background: '#F7F7F7',
      height: '46px',
      left: '25px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '1rem 0',
      borderRadius: '5px',
      padding: '10px',
      cursor: 'pointer'
    },
    machineDataList: {
      height: 'inherit',
      overflow: 'auto'
    },
    machineName: {
      color: '#000000',
      fontWeight: 500
    },
    machineCheckIcon: {
      background: '#5DBE30',
      color: '#FFFFFF',
      borderRadius: '50%',
      height: '15px',
      width: '15px'
    },
    machineDataHeaderText: {
      margin: '0.3rem 0',
      fontWeight: 600,
      color: '#000000'
    },
    noMachineDataHeaderText: {
      fontWeight: 500,
      color: '#000000',
      textAlign: 'center',
      margin: '20px 20px 20px 0'
    },
    machineCloseIcon: {
      background: DEFAULT_RED_COLOR,
      color: '#FFFFFF',
      borderRadius: '50%',
      height: '15px',
      width: '15px'
    },
    paymentDialogButtons: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    backIconView: {
      marginLeft: '-0.5rem',
      paddingBottom: '0.5rem',
      fontWeight: 'bold',
      display: 'flex',
      fontSize: '1.1rem',
      '&:first-child': {
        fontSize: '1.1rem'
      }
    },
    bottomRowButtons: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '1rem 0.3rem 0 0.3rem'
    },
    machineDataWrapper: {
      margin: '0 1rem 0 0'
    }
  })
);
// TODO: Give proper types to the below interface
interface MachineCardComponentProps {
  baseDetails: any;
  practiceMachinesList: any;
  practiceMachinesData: any;
  setPracticeMachinesData: any;
  isMachineDataLoading: any;
  setIsMachineDataLoading: any;
  setToInitialState: any;
  showCardMachineDetails: any;
  cardMachineDetails: any;
  setCardMachineDetailsObject: any;
  amount: any;
  statementBalance: any;
  copayBalance: any;
  otherChargeBalance: any;
  chargeTypeList: any;
  totalDue: any;
  clinicConvenienceFeeFlag: any;
  convenienceFee: any;
  totalChargeFee: any;
}

const MachineCardComponent = (
  props: MachineCardComponentProps | any
): React.ReactElement => {
  const {
    baseDetails,
    practiceMachinesList,
    practiceMachinesData,
    setPracticeMachinesData,
    isMachineDataLoading,
    setIsMachineDataLoading,
    setToInitialState,
    showCardMachineDetails,
    cardMachineDetails,
    setCardMachineDetailsObject,
    amount,
    statementBalance,
    copayBalance,
    otherChargeBalance,
    chargeTypeList,
    totalDue,
    clinicConvenienceFeeFlag,
    convenienceFee,
    totalChargeFee
  } = props;
  const classes = useStyles();

  const {t} = useTranslation();

  const {enqueueSnackbar} = useSnackbar();

  const [selectedMachineCard, setSelectedMachineCard]: any = useState('');

  const renderPracticeMachinesData = async (clinicDetails: any) => {
    try {
      const {clinicGroupId, clinicId} = clinicDetails;
      const payload = {
        clinic_group_id: clinicGroupId,
        clinic_id: clinicId
      };

      const res = await fetchCardMachineDetails(payload);
      if (res !== null && res.status_type === 'Success') {
        setIsMachineDataLoading(true);
        setPracticeMachinesData(res?.data?.rows);
        setIsMachineDataLoading(false);
      }
    } catch (err) {
      enqueueSnackbar(
        (err && err.message) || t('INSTALLMENTS.MACHINE_LIST_ERROR'),
        SnackBarConfig('e')
      );
      throw err;
    }
  };

  useEffect(() => {
    if (practiceMachinesList) {
      renderPracticeMachinesData(baseDetails);
    }
    // eslint-disable-next-line
  }, [practiceMachinesList]);

  const selectedMachineCardDetails = (response: any) => {
    setCardMachineDetailsObject(response);
    setSelectedMachineCard(response?.id);
    props._cardMachineDetailsObject({
      cardMachineDetailsObject: response
    });
  };

  return (
    <div
      className={['email-check-content-view', classes.machineDataContent].join(
        ' '
      )}>
      {practiceMachinesData?.length === 0 && (
        <Typography className={classes.backIconView} component={'div'}>
          <BackNavigation navigateTo={setToInitialState} />
        </Typography>
      )}
      {practiceMachinesData?.length > 0 && (
        <div className={classes.paymentsSection}>
          <ConfirmationDetails
            machinePayment={true}
            amount={amount}
            statementBalance={statementBalance}
            copayBalance={copayBalance}
            otherChargeBalance={otherChargeBalance}
            chargeTypeList={chargeTypeList}
            totalDue={totalDue}
            clinicConvenienceFeeFlag={clinicConvenienceFeeFlag}
            convenienceFee={convenienceFee}
            totalChargeFee={
              // calculateAmount()
              totalChargeFee
            }
          />
        </div>
      )}
      {practiceMachinesData?.length === 0 && (
        <div className={classes.noMachineDataHeaderText}>
          {t('INSTALLMENTS.NO_MACHINE_LIST')}
        </div>
      )}
      {practiceMachinesData?.length > 0 && (
        <div className={classes.machineDataList}>
          <div className={classes.machineDataHeaderText}>
            {t('INSTALLMENTS.MACHINE_LIST')}
          </div>

          <div className={classes.machineDataWrapper}>
            {practiceMachinesData.map((response: any, index: any) => {
              return (
                <div
                  key={index}
                  className={classes.machineData}
                  onClick={() => selectedMachineCardDetails(response)}
                  style={{
                    border:
                      selectedMachineCard === response?.id
                        ? '2px solid #2884ff'
                        : ''
                  }}>
                  <div className={classes.machineName}>
                    <b>{response?.machine_name}</b>{' '}
                    {`(${response?.serial_number})`}
                  </div>
                  <div>
                    {response?.status === 'active' ? (
                      <CheckIcon
                        className={classes.machineCheckIcon}
                        fontSize={'small'}
                      />
                    ) : (
                      <Close className={classes.machineCloseIcon} />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className={classes.bottomRowButtons}>
        {(practiceMachinesList || cardMachineDetails) &&
          practiceMachinesData?.length > 0 && (
            <Typography className={classes.backIconView} component={'div'}>
              <BackNavigation navigateTo={setToInitialState} />
            </Typography>
          )}
        {practiceMachinesData?.length > 0 && (
          <Button
            fullWidth
            variant="contained"
            size={'medium'}
            color="primary"
            className={[classes.selectCardButton].join(' ')}
            type={'submit'}
            disabled={selectedMachineCard === ''}
            style={{height: '3.5rem'}}
            onClick={showCardMachineDetails}>
            {isMachineDataLoading ? <Loader /> : t('INSTALLMENTS.SELECT')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default connect(
  () => {
    return {};
  },
  {
    _cardMachineDetailsObject
  }
)(MachineCardComponent);
